import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-left w-full flex flex-col gap-2 sf-pro" }
const _hoisted_2 = { class: "relative" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDropdown',
  props: {
    label: {},
    items: {},
    selectedItem: {},
    isDropdownOpen: { type: Boolean },
    borderColor: { default: "border-divider" },
    labelWidthClass: { default: "font-semibold" }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const triggerRef = ref<HTMLElement | null>(null);
const dropdownRef = ref<HTMLElement | null>(null);

function toggle() {
  emit("toggle");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["text-brown text-base leading-[20px] select-none", __props.labelWidthClass])
    }, _toDisplayString(__props.label), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        ref_key: "triggerRef",
        ref: triggerRef,
        type: "button",
        class: _normalizeClass(["w-full h-[52px] rounded-[14px] border focus:outline-none", {
          ...__props.borderColor,
          'opacity-40 pointer-events-none': __props.selectedItem === undefined,
        }]),
        onClick: toggle
      }, [
        _renderSlot(_ctx.$slots, "selectedItem", { item: __props.selectedItem }, () => [
          _createTextVNode(_toDisplayString(__props.selectedItem), 1)
        ])
      ], 2),
      (__props.isDropdownOpen && __props.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: dropdownRef,
            class: "absolute w-full rounded-[14px] border border-divider focus:outline-none right-0 z-10 mt-2 bg-white overflow-hidden"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                _renderSlot(_ctx.$slots, "dropdownItem", { item: item }, () => [
                  _createTextVNode(_toDisplayString(item), 1)
                ])
              ]))
            }), 128))
          ], 512))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})